const isPaymentPath = window.location.href.includes('payment/new') || window.location.href.includes('fill_participant_info');

if (isPaymentPath) {
  const lessonContainers = document.querySelectorAll('div.lesson');
  const rentalContainers = document.querySelectorAll('div.rental');
  const submitErrorEl = document.querySelector('#submit_error');

  document.addEventListener('turbolinks:load', function() {
    $('a[data-toggle="pill"]').on('shown.bs.tab', function(event) {
      $('#order_form').attr('action', $(event.target).data('action'));
    });

    // 「希望の時間帯」があれば、一個目の選択肢が選択されている状態にする
    lessonContainers.forEach(container => {
      const timeEls = container.querySelectorAll('input[name^="order_group[orders_attributes]"][type="checkbox"]');
      if (timeEls.length > 0) {
        timeEls[0].checked = true;
      }
    });
  });

  // 詳細確認・閉じるの切り替え
  const labelTranslations = {
    'jp': {'see_detail': '詳細確認', 'close': '閉じる'},
    'tw': {'see_detail': '確認詳情', 'close': '關閉'},
    'hk': {'see_detail': '確認詳情', 'close': '關閉'},
    'cn': {'see_detail': '确认详情', 'close': '关闭'},
    'www': {'see_detail': 'Confirm details', 'close': 'Close'},
    'au': {'see_detail': 'Confirm details', 'close': 'Close'},
  };

  const toggleBtns = document.querySelectorAll('.toggle-btn');
  const spanEls = document.querySelectorAll('.toggle-btn span');
  const chevronEls = document.querySelectorAll('.toggle-btn i');
  const dynamicContents = document.querySelectorAll('.dynamic-content');

  toggleBtns.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      dynamicContents[index].classList.toggle('hidden');
      if (spanEls[index].textContent === labelTranslations[subdomain]['see_detail']) {
        spanEls[index].textContent = labelTranslations[subdomain]['close'];
        chevronEls[index].classList.remove('fa-chevron-down');
        chevronEls[index].classList.add('fa-chevron-up');
      } else {
        spanEls[index].textContent = labelTranslations[subdomain]['see_detail'];
        chevronEls[index].classList.remove('fa-chevron-up');
        chevronEls[index].classList.add('fa-chevron-down');
      }
    });
  });

  let subdomain;

  if (window.location.hostname.includes('cn')) {
    subdomain = 'cn';
  } else {
    subdomain = window.location.hostname.split('.')[0];
  }

  const errorMsgTranslations = {
    valueMissing: {
      'jp': '必須項目を入力してください',
      'tw': '請輸入必填項目',
      'hk': '請填寫必填項目',
      'cn': '必填项目不得为空',
      'www': 'Please fill in the required item',
      'au': 'Please fill in the required item',
    },
    patternMismatch: {
      'jp': '正しい形式で入力してください',
      'tw': '請輸入正確的格式',
      'hk': '請以正確格式輸入',
      'cn': '请以正确的格式填写',
      'www': 'Please use correct format',
      'au': 'Please use correct format',
    },
    atLeastOneShouldBeFilled: {
      'jp': '最低一つを選択してください',
      'tw': '請至少選擇一項',
      'hk': '請至少選擇一項',
      'cn': '请至少选择一项',
      'www': 'Please select at least one',
      'au': 'Please select at least one',
    },
    termsShouldBeAgreed: {
      'jp': '購入するためには、本規約にご同意して頂く必要がございます',
      'tw': '您必須同意各項條款方可購買本商品',
      'hk': '您必須同意各項條款方可購買本商品',
      'cn': '您必须同意各项条款方可购买本商品',
      'www': 'To continue with purchase, you must agree to these terms.',
      'au': 'To continue with purchase, you must agree to these terms.',
    }
  };

  const fieldIds = [
    'first_name',
    'last_name',
    'wechat_email',
    'birth_year',
    'birth_month',
    'birth_day',
    'nation',
    'lesson_level',
    'emergency_contact_email',
    'emergency_contact_tel',
    'gender',
    'age',
    'height',
    'weight',
    'shoe_size',
    'wear_size',
    'additional_first_name',
    'additional_last_name',
    'tel',
    'buyer_phone_number',
    'checkin_time'
  ];

  const fillErrorEl = (errorEl, msg) => {
    const icon = document.createElement('i');
    icon.classList.add('fas', 'fa-exclamation-circle', 'mr-1');
    const errorMsgSpan = document.createElement('span');
    errorMsgSpan.textContent = msg;
    errorEl.appendChild(icon);
    errorEl.appendChild(errorMsgSpan);
  };

  const resetErrorEl = (errorEl) => {
    errorEl.textContent = '';
  };

  const applyErrorStyle = (el, errorClassName) => {
    el.classList.add('error');
  };

  const removeErrorStyle = (el, errorClassName) => {
    el.classList.remove('error');
  };

  const validateField = (fieldEl, errorEl) => {
    const value = fieldEl.value.trim();

    removeErrorStyle(fieldEl, 'error');

    if (fieldEl.required && value === '') {
      if (errorEl.childElementCount === 0) {
        fillErrorEl(errorEl, errorMsgTranslations.valueMissing[subdomain]);
      }
      applyErrorStyle(fieldEl, 'error');
      return false;
    } else if (fieldEl.pattern && !new RegExp(fieldEl.pattern).test(value)) {
      if (errorEl.childElementCount === 0) {
        fillErrorEl(errorEl, errorMsgTranslations.patternMismatch[subdomain]);
      }
      applyErrorStyle(fieldEl, 'error');
      return false;
    }
    return true;
  };

  const validateGuestGender = () => {
    const maleCountField = document.querySelector('[data-role="male-count"]');
    const femaleCountField = document.querySelector('[data-role="female-count"]');

    if (!maleCountField || !femaleCountField) { return true };

    const adultCount = parseInt(maleCountField.getAttribute('data-adultCount'), 10);
    const genderErrorField = document.getElementById('guest_gender_error');

    const maleCount = parseInt(maleCountField.value, 10) || 0;
    const femaleCount = parseInt(femaleCountField.value, 10) || 0;
    const totalCount = maleCount + femaleCount;

    if (totalCount !== adultCount) {
      genderErrorField.classList.remove('d-none');
      return false;
    } else {
      genderErrorField.classList.add('d-none');
      return true;
    }
  };

  fieldIds.forEach(fieldId => {
    if (['birth_year', 'birth_month', 'birth_day'].includes(fieldId)) {
      const fieldEl = document.querySelector(`#${fieldId}`);
      const errorEl = document.querySelector('#birth_error');
      if (fieldEl) {
        fieldEl.addEventListener('blur', () => validateField(fieldEl, errorEl));
        fieldEl.addEventListener('focus', () => {
          submitErrorEl.classList.remove('show');
          removeErrorStyle(fieldEl, 'error');
          const birthEls = [document.querySelector('#birth_year'), document.querySelector('#birth_month'), document.querySelector('#birth_day')];
          if (!birthEls.some(el => el.classList.contains('error'))) {
            resetErrorEl(errorEl);
          }
        });
      }
    } else if (['lesson_level'].includes(fieldId)) {
      lessonContainers.forEach(container => {
        const selectEl = container.querySelector(`#${fieldId}`);
        if (selectEl) {
          const errorEl = container.querySelector(`#${fieldId}_error`);
          selectEl.addEventListener('blur', () => validateField(selectEl, errorEl));
          selectEl.addEventListener('focus', () => {
            submitErrorEl.classList.remove('show');
            removeErrorStyle(selectEl, 'error');
            resetErrorEl(errorEl);
          });
        }
        // 「希望の時間帯」は、他の入力欄と同じバリデーションが使えないため、
        // 独自のバリデーションを適用する
        const timeEls = container.querySelectorAll('input[name^="order_group[orders_attributes]"][type="checkbox"]');
        const timeErrorEl = container.querySelector('#time_error');
        if (timeEls.length > 0) {
          timeEls.forEach(el => {
            el.addEventListener('focus', () => {
              // ここのel（input）自体は、表示されない
              // 実際に表示されているのはelの親要素のため、
              // スタイルもすべて親要素に適用する必要がある
              submitErrorEl.classList.remove('show');
              el.parentElement.classList.add('focused');
              removeErrorStyle(el.parentElement, 'error');
              resetErrorEl(timeErrorEl);
            });
            el.addEventListener('blur', () => {
              el.parentElement.classList.remove('focused');
              // 上記のclass名削除と非同期処理することで、
              // 下記function内の判定が行われる時、
              // class名が確実に削除されていることを担保できる
              setTimeout(function() {
                if (!Array.from(timeEls).some(el => el.parentElement.classList.contains('focused'))) {
                  if (!Array.from(timeEls).some(el => el.checked)) {
                    if (timeErrorEl.childElementCount === 0) {
                      fillErrorEl(timeErrorEl, errorMsgTranslations.atLeastOneShouldBeFilled[subdomain]);
                    }
                    timeEls.forEach(el => el.parentElement.classList.add('error'));
                  } else {
                    timeErrorEl.innerHTML = '';
                    timeEls.forEach(el => el.parentElement.classList.remove('error'));
                  }
                }
              }, 100);
            });
          });
        }
      });
    // レンタル
    } else if (['gender', 'age', 'height', 'weight', 'shoe_size', 'wear_size'].includes(fieldId)) {
      rentalContainers.forEach(container => {
        const people = container.querySelectorAll('div.person');
        people.forEach((person, index) => {
          const fieldEl = person.querySelector(`#${fieldId}`);
          const errorEl = person.querySelector(`#${fieldId}_error`);
          if (fieldEl) {
            fieldEl.addEventListener('blur', () => validateField(fieldEl, errorEl));
            fieldEl.addEventListener('focus', () => {
              submitErrorEl.classList.remove('show');
              removeErrorStyle(fieldEl, 'error');
              resetErrorEl(errorEl);
            });
          }
        });
      });
    } else if (['checkin_time'].includes(fieldId)) {
      const fieldEl = document.querySelector(`#${fieldId}`);
      const errorEl = document.querySelector(`#${fieldId}_error`);
      if (fieldEl) {
        fieldEl.addEventListener('blur', () => validateField(fieldEl, errorEl));
        fieldEl.addEventListener('focus', () => {
          submitErrorEl.classList.remove('show');
          removeErrorStyle(fieldEl, 'error');
          resetErrorEl(errorEl);
        });
      }
    } else {
      const fieldEl = document.querySelector(`#${fieldId}`);
      const errorEl = document.querySelector(`#${fieldId}_error`);
      if (fieldEl) {
        fieldEl.addEventListener('blur', () => validateField(fieldEl, errorEl));
        fieldEl.addEventListener('focus', () => {
          submitErrorEl.classList.remove('show');
          removeErrorStyle(fieldEl, 'error');
          resetErrorEl(errorEl);
        });
      }
    }
  });

  const form = document.querySelector('#order_form');
  const requiredFields = document.querySelectorAll('input[required], select[required]');
  const submitBtn = document.querySelector('button[type=submit]');

  const findAncestorWithClass = (el, className) => {
    let parent = el;
    while (parent && !parent.classList.contains(className)) {
      parent = parent.parentNode;
    }
    return parent;
  };

  form.addEventListener('submit', function(event) {
    let isValid = true;

    // 画面左側の各入力欄
    for(let field of requiredFields) {
      let errorEl = document.querySelector(`#${field.id}_error`);
      if (['birth_year', 'birth_month', 'birth_day'].includes(field.id)) {
        errorEl = document.querySelector('#birth_error');
      } else if (['lesson_level'].includes(field.id)) {
        const parent = findAncestorWithClass(field, 'lesson');
        errorEl = parent.querySelector(`#${field.id}_error`);
      } else if (['emergency_contact_email'].includes(field.id)) {
        const parent = field.parentNode;
        errorEl = parent.querySelector(`#${field.id}_error`);
      } else if (['emergency_contact_tel'].includes(field.id)) {
        const parent = field.parentNode;
        errorEl = parent.querySelector(`#${field.id}_error`);
      } else if (['gender', 'age', 'height', 'weight', 'shoe_size', 'wear_size'].includes(field.id)) {
        const parent = findAncestorWithClass(field, 'person');
        errorEl = parent.querySelector(`#${field.id}_error`);
      } else if (['checkin_time'].includes(field.id)) {
        errorEl = document.querySelector(`#${field.id}_error`);
      } else {
        const parent = field.parentNode;
        errorEl = parent.querySelector(`#${field.id}_error`);
      }
      if (!validateField(field, errorEl)) {
        isValid = false;
        submitErrorEl.classList.add('show');
        submitBtn.removeAttribute('disabled');
        submitBtn.removeAttribute('data-disable-with');
        window.scrollTo(0, 0);
      }
    }

    // 宿泊者性別（大人）のバリデーション
    if (!validateGuestGender()) {
      isValid = false;
      submitErrorEl.classList.add('show');
      submitBtn.removeAttribute('disabled');
      submitBtn.removeAttribute('data-disable-with');
      window.scrollTo(0, 0);
    }

    // 利用予定日のバリデーション
    const scheduledDateForm = document.querySelector('#scheduled-date-form')
    if (scheduledDateForm && !scheduledDateForm.value) {
      isValid = false;
      submitErrorEl.classList.add('show');
      submitBtn.removeAttribute('disabled');
      submitBtn.removeAttribute('data-disable-with');
      window.scrollTo(0, 0);
    }

    // 条約同意チェック
    const termsOfService = document.querySelector('#terms_of_service_agreement')
    if (termsOfService && !termsOfService.checked) {
      isValid = false;
      let errorEl = document.querySelector('#terms_of_service_agreement_error');
      if (errorEl.childElementCount === 0) {
        fillErrorEl(errorEl, errorMsgTranslations.termsShouldBeAgreed[subdomain]);
      }
      submitBtn.removeAttribute('disabled');
      submitBtn.removeAttribute('data-disable-with');
    }

    if (isValid) {
      submitBtn.setAttribute('data-disable-with', '<i class="fas fa-spinner fa-spin px-4"></i>');
    } else {
      event.preventDefault();
    }
  });
};
